import * as React from "react"
import { NavItem, NavLink } from "shards-react"

import { routify } from "../js/routify"

const NavigationLink = props => (
  <NavItem>
    <NavLink href={routify(props.countryCode, props.href)}>
      {props.title}
    </NavLink>
  </NavItem>
)

export default NavigationLink
